<template>
  <div class="flex a-start">
    <div class="flex-1 flex-s-0">
      <div :key="index"
           :style="{paddingLeft:hSpacing,paddingRight:hSpacing,paddingTop:vSpacing,paddingBottom:vSpacing}"
           v-for="(item,index) in leftList">
        <div style="max-height: 252px;overflow: hidden">
          <img :src="item.picurl" alt="" class="w-full v-a-top">
        </div>
      </div>
    </div>
    <div class="flex-1 flex-s-0">
      <div :key="index" :style="{paddingLeft:hSpacing,paddingRight:hSpacing,paddingTop:vSpacing,paddingBottom:vSpacing}"
           v-for="(item,index) in rightList">
        <div style="max-height: 252px;overflow: hidden">
          <img :src="item.picurl" alt="" class="w-full v-a-top">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {getWaterFlowData} from '../../utils/waterflow'

export default {
  name: 'WaterFlowComponent',
  props: {
    imgInfo: {
      type: Array,
      default: () => {
        return []
      }
    },
    hSpacing: String,
    vSpacing: String
  },
  watch: {
    imgInfo: {
      handler (newValue) {
        if (newValue && newValue.length) {
          let {leftList, rightList} = getWaterFlowData(newValue)
          this.leftList = leftList || []
          this.rightList = rightList || []
        } else {
          this.leftList = []
          this.rightList = []
        }
      },
      deep: true,
      immediate: true
    }
  },
  data () {
    return {
      leftList: [],
      rightList: []
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {

    }
  }
}
</script>

<style lang="scss" scoped>

</style>
